import { React, Component } from 'react';

import style from './style';

class NewsLetterFooter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loader       : false,
			disabledFlag : true,
			email        : '',
			verifyEmail  : false,
			statusCheck  : false,
			counter      : 0
		};

		this.handleContacts = this.handleContacts.bind(this);
		this.resetValue = this.resetValue.bind(this);
	}

	componentWillUnmount() {
		this.resetValue();
	}

	resetValue = () => {
		this.setState({
			email : ''
		});
	};

	handleContacts = () => {
		const { counter, email, verifyEmail } = this.state;

		var emailobj = {};
		emailobj.email = email;
		if (verifyEmail && counter < 1) {
			this.setState({
				loader : true
			});
			fetch('https://dev365.gdpventure.com/drupal-backend/api/post.json', {
				method : 'POST',
				body   : JSON.stringify(emailobj)
			}).then((response) => {
				if (response.ok) {
					this.setState({
						loader       : false,
						disabledFlag : true,
						counter      : counter + 1
					});
					response.json().then((json) => {
						this.setState({
							statusCheck : true
						});
					});
				}
				else {
					this.setState({
						statusCheck : false
					});
				}
			});
		}
	};

	onChange = (e) => {
		this.setState({
			email : e.target.value
		});
		var docCount;
		if (this.props.idForIdentification && this.props.idForIdentification === 'hp') {
			docCount = 1;
		}
		else if (this.props.idForIdentification && this.props.idForIdentification === 'pf') {
			docCount = 0;
		}

		if (docCount === 0 || docCount === 1) {
			document.getElementsByClassName(style.subscribe)[docCount].disabled = false;
		}
		else {
			document.getElementsByClassName(style.subscribe)[0].disabled = false;
		}

		if (/^([a-zA-Z0-9][\w\.]{0,})?[a-zA-Z0-9]@([^\.\_\@][\w]{0,}[\.])+[\w]{1,}$/.test(e.target.value)) {
			this.setState({
				disabledFlag : false,
				verifyEmail  : true
			});

			return true;
		}
		else {
			this.setState({
				disabledFlag : true,
				verifyEmail  : false
			});

			return false;
		}
	};

	render() {
		return (
			<div class={style.NewsLetterFooter}>
				<p id={style.newsletterText}>NEWSLETTER</p>

				<p class={style.subscribeText}>
					Dont miss out on the latest news and updates about our ever changing world
				</p>
				<div class={style.flexbox}>
					<input
						class={style.emailBox}
						type="text"
						placeholder="Enter your email here"
						onInput={(e) => this.onChange(e)}
					/>
					<button
						class={style.subscribe}
						onClick={this.handleContacts}
						disabled={this.state.disabledFlag}
						style={this.state.disabledFlag ? 'cursor:not-allowed' : 'cursor:pointer'}
					>
						{this.state.loader ? (
							<div class={style.loading} />
						) : this.state.statusCheck ? (
							<p>DONE</p>
						) : (
							<p style={this.state.verifyEmail ? 'opacity:1' : 'opacity:0.5'}>SUBSCRIBE</p>
						)}
					</button>
				</div>
			</div>
		);
	}
}
export default NewsLetterFooter;



// WEBPACK FOOTER //
// ./components/NewsLetterFooter/index.js